import { createAction } from 'redux-actions';

export const selectReceiver = createAction('STATISTICS_SELECT_RECEIVER');
export const selectSender = createAction('STATISTICS_SELECT_SENDER');
export const statisticsType = createAction('STATISTICS_SELECT_TYPE');
export const selectReportYears = createAction('STATISTICS_SELECT_REPORT_YEARS');
export const selectReportRows = createAction('STATISTICS_SELECT_REPORT_ROWS');
export const resetStatisticsTransferTable = createAction(
  'RESET_STATISTICS_TRANSFER_TABLE'
);
